import { render, staticRenderFns } from "./SaleBindGoods.vue?vue&type=template&id=0efcf573&scoped=true&"
import script from "./SaleBindGoods.vue?vue&type=script&lang=ts&"
export * from "./SaleBindGoods.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efcf573",
  null
  
)

export default component.exports